class Gallery extends HTMLElement {
  constructor(id) {
    super(id);

    const scripts = ["https://unpkg.com/swiper@8.4.4/swiper-bundle.min.js"];

    const init = this.init;
    this.id = id;

    const loadScript = (url) => {
      return new Promise((resolve, reject) => {
        let script = document.createElement("script");
        script.src = url;
        script.async = false;
        script.onload = () => {
          resolve(url);
        };
        script.onerror = () => {
          reject(url);
        };
        document.head.appendChild(script);
      });
    };

    // save all Promises as array
    let promises = [];
    scripts.forEach((url) => {
      promises.push(loadScript(url));
    });

    Promise.all(promises)
      .then(() => {})
      .catch((script) => {
        console.log(script + " failed to load");
      });
  }

  init(data, altTexts) {
    const haveMultipleImages = data.length > 1;
    const container = document.createElement("div");
    container.id = `gallery-${this.id}`;
    container.classList.add("gallery-container");

    if(haveMultipleImages) {
      container.classList.add("withArrows");
    }
      
    const swiperElement = document.createElement("div");
    swiperElement.classList.add("gallery", "swiper");

    const wrapperElement = document.createElement("div");
    wrapperElement.classList.add("swiper-wrapper");
    swiperElement.appendChild(wrapperElement);
    container.appendChild(swiperElement);
    
    const swiperPaginationIndicatorsElement = document.createElement('div');
    swiperPaginationIndicatorsElement.classList.add('swiper-custom-pagination', 'dots-wrapper');
    container.appendChild(swiperPaginationIndicatorsElement);
    
    let isOnLeftSide = true;
    const handleMouseMove = (event) => {
      const containerWidth = event.target.offsetWidth;
      isOnLeftSide = containerWidth / event.offsetX > 2;
      
      if (isOnLeftSide) {
        container.classList.remove("gallery-container--right");
        container.classList.add("gallery-container--left");
      } else {
        container.classList.remove("gallery-container--left");
        container.classList.add("gallery-container--right");
      }
    };

    const swiperOptions = {
      allowTouchMove: window.innerWidth < 900,
      loop: haveMultipleImages,
      initialSlide : 1,
      pagination: {
        el: swiperPaginationIndicatorsElement,
        clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + ' dot"></span>';
          },
      },
    };

    const handleClick = () => {
      if (isOnLeftSide) {
        swiper.slidePrev(300);
      } else {
        swiper.slideNext(300);
      }
    };
    
    if (haveMultipleImages) {
      if (window.innerWidth >= 900) {
        container.addEventListener("mousemove", handleMouseMove);
        container.addEventListener("click", handleClick);
      }
    }
    const swiper = new Swiper(swiperElement, swiperOptions);

    data.forEach((item, index) => {
      const element = document.createElement("div");
      element.classList.add("swiper-slide");
      const image = document.createElement("img");
      image.src = item;
      if(altTexts){
        if(altTexts[index]){
          image.alt = Object.values(altTexts[index]).join('');
        }
      }
      image.classList.add("gallery-image");
      element.appendChild(image);
      swiper.appendSlide(element);
    });

    return container;
  }
}

if (!customElements.get("gallery-component")) {
  customElements.define("gallery-component", Gallery);
}
